module.exports = __webpack_public_path__ + "uploadPortfolios.d6d7fa62311ac006919d98a7b226d51c.svg";